import React from 'react'
import './OACForm.scss'
import CustomInput from '../../shared/CustomInput/CustomInput';
import { Box } from '@mui/material';
import UnifiedButton from '../../shared/Button';

function OACForm() {
    return (
        <Box className="artist-form-section">
            <div className="form-row">
                <CustomInput
                    label="First Name"
                    placeholder="Enter your first name"
                    fullWidth
                />
                <CustomInput
                    label="Last Name"
                    placeholder="Enter your last name"
                    fullWidth
                />
            </div>

            <div className="form-row">
                <CustomInput label="Email" placeholder="Enter your email" fullWidth />
                <CustomInput
                    label="Mobile no."
                    placeholder="Enter your mobile number"
                    fullWidth
                />
            </div>

            <div className="form-row">
                <CustomInput
                    label="Artist Name"
                    placeholder="Enter the artist name"
                    fullWidth
                />
                <CustomInput
                    label="Artist Youtube Channel"
                    placeholder="Enter the Youtube channel URL"
                    fullWidth
                />
            </div>

            <div className="form-row">
                <CustomInput
                    label="Artist Topic Channel"
                    placeholder="Enter the artist topic channel"
                    fullWidth
                />

            </div>

            <CustomInput
                label="Artist Three Songs Youtube Topic URL (Distributed by FM Digital Official)"
                placeholder="Enter the songs' Youtube topic URLs"
                fullWidth
            />
            <Box
                sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
            >
                <UnifiedButton
                    className={"artist-form-button"}
                    variant="contained"
                    textContent={"Submit"}
                    fullWidth
                    sx={{ mt: 2, color: "white" }}
                />
            </Box>
        </Box>
    );
}

export default OACForm
